import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AppComponent {
  // addcheckbox='true'
  // title = 'component-library';

  // showtoastr = 'yes';

  // message = "this is my message";

  // title1 = "Title";

  // status = 'success';

  // validExt = 'csv,xls,xlsx,tab,pdf';
  // resizable = false;

  // title1 = { show: false, text: '', subtext: '', left: 'center' };
  // title2 = { show: true, text: 'My Piechart', subtext: 'sub pie', left: 'left' };

  // tooltip1 = {"show": false, "trigger":"item", "confine": true};
  // tooltip2 = {"show": true, "trigger":"item", "confine": true};

  // legend1 = { orient: 'vertical', left: 'left', data: ['USA', 'Germany', 'France', 'Canada', 'Russia']};
  // legend2 = { orient: 'horizontal', left: 'right'};

  // showtoastr=true;

  // series1 = [
  //   {
  //     name: 'Countries',
  //     type: 'pie',
  //     radius: '80%',   
  //     center: ['50%', '50%'],
  //     data: [
  //       { value: 335, name: 'Germany' },
  //       { value: 310, name: 'France' },
  //       { value: 234, name: 'Canada' },
  //       { value: 135, name: 'Russia' },
  //       { value: 1548, name: 'USA' },
  //     ],
  //     itemStyle: {
  //       emphasis: {
  //         shadowBlur: 10,
  //         shadowOffsetX: 0,
  //         shadowColor: 'rgba(0, 0, 0, 0.5)',
  //       },
  //     },
  //     label: {
  //       normal: {
  //         textStyle: {
  //           color: '#1a2138',
  //         },
  //       },
  //     },
  //     labelLine: {
  //       normal: {
  //         lineStyle: {
  //           color: '#1a2138',
  //         },
  //       },
  //     },
  //   },
  // ]

  // series2 = [
  //   {
  //     name: 'Food',
  //     type: 'pie',
  //     radius: '40%',
  //     center: ['50%', '50%'],
  //     data: [
  //       { value: 335, name: 'Pasta' },
  //       { value: 310, name: 'Dumplings' },
  //       { value: 234, name: 'Burritos' },
  //       { value: 135, name: 'Steak' },
  //       { value: 1548, name: 'Fries' },
  //     ],
  //     itemStyle: {
  //       emphasis: {
  //         shadowBlur: 10,
  //         shadowOffsetX: 0,
  //         shadowColor: 'rgba(0, 0, 0, 0.5)',
  //       },
  //     },
  //     label: {
  //       normal: {
  //         textStyle: {
  //           color: '#1a2138',
  //         },
  //       },
  //     },
  //     labelLine: {
  //       normal: {
  //         lineStyle: {
  //           color: '#1a2138',
  //         },
  //       },
  //     },
  //   },
  // ]
  
  // titleopt = JSON.stringify(this.title1);
  // tooltip = JSON.stringify(this.tooltip1);
  // legend = JSON.stringify(this.legend1);
  // series = JSON.stringify(this.series1);

  // tip = "one"

  // getjson()
  // {

  //   if (this.tip == "one")
  //   {
  //     this.tip = "two"
  //     this.tooltip = JSON.stringify(this.tooltip2)
  //     this.legend = JSON.stringify(this.legend2)
  //     this.series = JSON.stringify(this.series2)
  //     this.titleopt = JSON.stringify(this.title2);
  //   }
  //   else
  //   {
  //     this.tip="one"
  //     this.tooltip = JSON.stringify(this.tooltip1)
  //     this.legend = JSON.stringify(this.legend1)
  //     this.series = JSON.stringify(this.series1)
  //     this.titleopt = JSON.stringify(this.title1);
  //   }

  //   // this.tooltip = JSON.stringify(value);
  // }


  // // series =  [
  // //   {
  // //     name: 'Mail marketing',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [120, 132, 101, 134, 90, 230, 210],
  // //   },
  // //   {
  // //     name: 'Affiliate advertising',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [220, 182, 191, 234, 290, 330, 310],
  // //   },
  // //   {
  // //     name: 'Video ad',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [150, 232, 201, 154, 190, 330, 410],
  // //   },
  // //   {
  // //     name: 'Direct interview',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [320, 332, 301, 334, 390, 330, 320],
  // //   },
  // //   {
  // //     name: 'Search engine',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // label: {
  // //     //   normal: {
  // //     //     show: true,
  // //     //     position: 'top',
  // //     //     textStyle: {
  // //     //       color: colors.textColor,
  // //     //     },
  // //     //   },
  // //     // },
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  // //   },
  // //   {
  // //     name: 'Data',
  // //     type: 'line',
  // //     stack: 'Total amount',
  // //     // areaStyle: { normal: { opacity: colors.areaOpacity } },
  // //     data: [125, 130, 100, 130, 95, 230, 210],
  // //   },
  // // ];
  // expandAll = 'false';
  // collapseAll = 'false';

  // exp = false
  // coll = false
  // dosome(togtype){
  //   if (togtype === 'expand') {
  //     this.exp = !this.exp
  //     if (this.exp) {
  //       this.collapseAll = 'false'
  //       this.coll = false
  //       this.expandAll = 'true'
  //     }
  //     else {
  //       this. expandAll = 'false'
  //     }
  //   }
  //   else {
  //     if (!this.coll) {
  //       this.coll = !this.coll
  //       console.log(this.coll)
  //       if (this.coll) {
  //         this.expandAll = 'false'
  //         this.exp = false
  //         this.collapseAll = 'true'
  //       }
  //       else {
  //         this.collapseAll = 'false'
  //       }
  //     }
      
      
  //   }
  // }

  // showSelected(e) {
  //   var selectionModel = e.source
  //   console.log(selectionModel)
  // }

  // apiUrl = "http://10.190.116.40:3015/assets/data/mock-table.json";
 
  // getUrl(value) {
  //   // console.log(value);
  //   this.apiUrl = value;
  // }

  // opts = [
  //   {value: "val 1", label: "Daisy"},
  //   {value: "val 2", label: "Rose", disabled: true},
  //   {value: "val 3", label: "Dandelion"},
  //   {value: "val 4", label: "Dahlia"},
  //   {value: "val 5", label: "Daffodil"},
  // ]
//   prof1= true
  
//   profileData1 = `[
//     {
//       "id": 1,
//       "name": "Extreme High Risk",
//       "Mobile Universe": "200,000",
//       "Risk Score (Top 1-5%)": "0.83",
//       "Risk Score (Top 6-10%)": "0.78",
//       "expanded": "false",
//       "__parent": "parent",
//       "__color": "#fbd0da",
//       "__bgColor": "#B81037"           
//     },
//     {
//       "id": 2,
//       "name": "ATTRIBUTE 1",
//       "Mobile Universe": "3,000",
//       "Risk Score (Top 1-5%)": "1.25",
//       "Risk Score (Top 6-10%)": "0.67",
//       "expanded": "false",
//       "__parent": "1",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 3,
//       "name": "ATTRIBUTE 2",
//       "Mobile Universe": "3,000",
//       "Risk Score (Top 1-5%)": "1.48",
//       "Risk Score (Top 6-10%)": "0.70",
//       "expanded": "false",
//       "__parent": "1",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 4,
//       "name": "High Risk",
//       "Mobile Universe": "300,000",
//       "Risk Score (Top 1-5%)": "3.20",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "parent",
//       "__color": "#B81037",
//       "__bgColor": "#fbd0da"
//     },
//     {
//       "id": 5,
//       "name": "ATTRIBUTE 3",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "1.14",
//       "expanded": "false",
//       "__parent": "4",
//       "__color": "#5f071c"
//     },
//     {
//       "id": 6,
//       "name": "ATTRIBUTE 4",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "4",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 7,
//       "name": "Low Risk",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "parent",
//       "__color": "#0d5f07",
//       "__bgColor": "#d2fbd0"
//     },
//     {
//       "id": 8,
//       "name": "ATTRIBUTE 5",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "7",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 9,
//       "name": "ATTRIBUTE 6",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "7",
//       "__color": "#3C3939"
      
//     },
//     {
//       "id": 10,
//       "name": "Extreme Low Risk",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "parent",
//       "__color": "#d2fbd0",
//       "__bgColor": "#0d5f07"
//     },
//     {
//       "id": 11,
//       "name": "ATTRIBUTE 7",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "10",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 12,
//       "name": "ATTRIBUTE 8",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "10",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 13,
//       "name": "Neutral Risk",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "parent",
//       "__color": "#000000"
//     },
//     {
//       "id": 14,
//       "name": "ATTRIBUTE 9",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "13",
//       "__color": "#3C3939"
//     },
//     {
//       "id": 15,
//       "name": "ATTRIBUTE 10",
//       "Mobile Universe": "100,000",
//       "Risk Score (Top 1-5%)": "1.30",
//       "Risk Score (Top 6-10%)": "2.07",
//       "expanded": "false",
//       "__parent": "13",
//       "__color": "#3C3939"}]`

//       profileData2 = `[
//         {
//           "id": 1,
//           "name": "Extreme High Risk",
//           "Mobile Universe": "200,000",
//           "Risk Score (Top 1-5%)": "0.83",
//           "Risk Score (Top 6-10%)": "0.78",
//           "expanded": "false",
//           "__parent": "parent",
//           "__color": "#fbd0da",
//           "__bgColor": "#B81037"           
//         },
//         {
//           "id": 2,
//           "name": "TEST 2",
//           "Mobile Universe": "3,000",
//           "Risk Score (Top 1-5%)": "1.25",
//           "Risk Score (Top 6-10%)": "0.67",
//           "expanded": "false",
//           "__parent": "1",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 3,
//           "name": "ATTRIBUTE 2",
//           "Mobile Universe": "3,000",
//           "Risk Score (Top 1-5%)": "1.48",
//           "Risk Score (Top 6-10%)": "0.70",
//           "expanded": "false",
//           "__parent": "1",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 4,
//           "name": "High Risk",
//           "Mobile Universe": "300,000",
//           "Risk Score (Top 1-5%)": "3.20",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "parent",
//           "__color": "#B81037",
//           "__bgColor": "#fbd0da"
//         },
//         {
//           "id": 5,
//           "name": "ATTRIBUTE 3",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "1.14",
//           "expanded": "false",
//           "__parent": "4",
//           "__color": "#5f071c"
//         },
//         {
//           "id": 6,
//           "name": "ATTRIBUTE 4",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "4",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 7,
//           "name": "Low Risk",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "parent",
//           "__color": "#0d5f07",
//           "__bgColor": "#d2fbd0"
//         },
//         {
//           "id": 8,
//           "name": "ATTRIBUTE 5",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "7",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 9,
//           "name": "ATTRIBUTE 6",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "7",
//           "__color": "#3C3939"
          
//         },
//         {
//           "id": 10,
//           "name": "Extreme Low Risk",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "parent",
//           "__color": "#d2fbd0",
//           "__bgColor": "#0d5f07"
//         },
//         {
//           "id": 11,
//           "name": "ATTRIBUTE 7",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "10",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 12,
//           "name": "ATTRIBUTE 8",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "10",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 13,
//           "name": "Neutral Risk",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "parent",
//           "__color": "#000000"
//         },
//         {
//           "id": 14,
//           "name": "ATTRIBUTE 9",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "13",
//           "__color": "#3C3939"
//         },
//         {
//           "id": 15,
//           "name": "ATTRIBUTE 10",
//           "Mobile Universe": "100,000",
//           "Risk Score (Top 1-5%)": "1.30",
//           "Risk Score (Top 6-10%)": "2.07",
//           "expanded": "false",
//           "__parent": "13",
//           "__color": "#3C3939"}]`

//         profileData = this.profileData1

}
